import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useIsUnifiedInboxRoute } from "@circle-react/hooks/chatsV2/messaging/useIsUnifiedInboxRoute";

import { t } from "@/i18n-js/instance";
import { Typography } from "@/react/components/SettingsApp/CompassCompat/Typography";

export const EmptyChat = () => {
  const isUnifiedInboxRoute = useIsUnifiedInboxRoute();

  return (
    <div
      className={classNames("flex flex-col items-center justify-center", {
        "h-[calc(100dvh-160px)]": !isUnifiedInboxRoute,
        "flex-1": isUnifiedInboxRoute,
      })}
    >
      <Typography.LabelMd weight="semibold">
        {t("community_inbox.chats.no_conversations")}
      </Typography.LabelMd>
      <Typography.LabelSm>
        {t("community_inbox.chats.no_conversations_description")}
      </Typography.LabelSm>
    </div>
  );
};
